module.exports = __webpack_public_path__ + "img/retrieve-myinfo-singpass-btn-primary.9f585bca.png";